<template>
    <div class="modal-step-container">
        <shareSheet
            :postID="sharePostData.postID"
            :gifURL="sharePostData.gifURL"
            v-if="shareSheetShown"
            @hideShareSheet="shareSheetShown=false"
        />
        <div v-if="gifImage.url != null">
            <div class="gif-img quiz-created-gif">
                <img :src="gifImage.url" alt="">
            </div>
            <div class="modal-btns-cont">
                <a class="btn btn-l btn-primary btn-icon-16 btn-icon-download-white qc-download-btn"
                    :href="gifImage.url"
                    target="_blank"
                    download>
                    Download
                </a>
                <a
                    class="btn btn-l btn-secondary btn-icon-16 btn-icon-share qc-share-btn"
                    @click="shareSheetShown=true"
                    >
                    Share
                </a>
                <a @click.stop.prevent="backToHomepage" class="back-to-home-link">Back to Homepage</a>
            </div>
        </div>
        <div class="loading-gif-cont" v-if="gifImage.url == null">
            <div class="loading-spinner"></div>
            <div class="loading-gif-desc">Your awesome gif is being created</div>
        </div>
    </div>
</template>

<script>
import shareSheet from '@/components/shareSheet'

export default {
    name: "gifCreationStep3",
    components: {
        shareSheet,
    },
    props: {
        gifImage: Object,
        sharePostData: Object,
    },
    data() {
        return {
            stepData: {
                title: null,
            },
            shareSheetShown: false,
        }
    },
    methods: {
        emitData() {
            this.$emit('stepData', this.stepData);
        },
        backToHomepage() {
            this.$emit('backToHomepage');
        },
    },
    watch: {
        gifImage: {
            handler() {
                this.stepData.title = "Quiz Created!"
                this.emitData();
            },
            deep: true,
        },
    },
    mounted() {
        this.emitData();
    }
}
</script>

<style>

</style>